<div *ngFor="let err of errors" class="error-message" [class.table-err]="type === 'table-err'">
  {{ err }}
</div>
